module.exports = __webpack_public_path__ + "static/img/RAZ-DG_1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/produkty/RAZ-DG_1.png
// module id = Q/28
// module chunks = 0